import { request } from '../../services/request';
import { PaginatedDataStore } from '../paginated-data.store';
import { ATsetupFile } from '../atsetup.type';
import {
    AbstractSocialTradingStore,
    GetFilterValuesResponse,
    PaginationInterface,
} from './abstract-social-trading.store';

export interface Storage {
    id: number;
    user_id: number;
    hash: string;
    path: string;
    type: string;
    size: number;
    created_at: Date;
    updated_at?: any;
}

export interface Photo {
    storage_id: number;
    type: string;
    url: string;
}

export interface Postable {
    name: string;
}

export interface PostDocument {
    storage_id: number;
    name: string;
}

export interface Post {
    id: number;
    entry: string;
    entry_id: number;
    content: string;
    photos: Photo[];
    postable: Postable;
    documents: PostDocument[];
}
//

// generated by json2ts
export interface Price {
    Price: number;
}

export interface StopPrice {
    Price: number;
}

export interface SharedTradeInterface {
    id: string;
    symbol: string;
    setup_text: string;
    setup_file: ATsetupFile;
    type: string;
    posts: Post[];
}
export interface SharedTradeFiltersInterface {
    date_lower?: string;
    date_upper?: string;
    group?: number;
    symbol?: string;
    author?: number;
    user?: number;
    webinar?: number;
}

export class TradeSharingStore extends AbstractSocialTradingStore<SharedTradeInterface, SharedTradeFiltersInterface> {
    createPaginatedDataStore(): PaginatedDataStore<SharedTradeInterface, SharedTradeFiltersInterface> {
        return new PaginatedDataStore(async (page, filters) => {
            const response = await request.get<PaginationInterface<SharedTradeInterface>>(
                '/api/v2.0/trade-sharing/trades',
                {
                    params: {
                        page,
                        ...(filters.date_upper && { date_upper: filters.date_upper }),
                        ...(filters.date_lower && { date_lower: filters.date_lower }),
                        ...(filters.symbol && { symbol: filters.symbol }),
                        ...(filters.group && { group: filters.group }),
                        ...(filters.webinar && { webinar: filters.webinar }),
                        ...(filters.author && { author: filters.author }),
                        ...(filters.user && { user: filters.user }),
                    },
                }
            );

            return {
                data: response.data.data,
                hasNextPage: page < response.data.last_page,
            };
        });
    }

    async fetchFilterOptions() {
        const { data } = await request.get<GetFilterValuesResponse>('/api/v2.0/trade-sharing/filter-values');
        return data;
    }
}

export const tradeSharingStore = new TradeSharingStore();
